import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostAcceptWellBornProgram,
	PostAcceptWellBornProgramParams,
	PostAcceptWellBornProgramResponse,
} from 'domain/usecases/private/well-born/post-accept-well-born-program';

export class RemoteAcceptWellBornProgram implements PostAcceptWellBornProgram {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostAcceptWellBornProgramResponse>,
	) {}

	async accept(
		params: PostAcceptWellBornProgramParams,
	): Promise<PostAcceptWellBornProgramResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
